function SvgNoteWhite({ fill, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g id="Note-icon-white" transform="translate(-88.533 -3.345)">
        <g
          id="Rectangle_178"
          data-name="Rectangle 178"
          transform="translate(88.533 3.345)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="1.5"
        >
          <rect width="18" height="18" rx="2" stroke="none" />
          <rect x="0.75" y="0.75" width="16.5" height="16.5" rx="1.25" fill="none" />
        </g>
        <line
          id="Ligne_90"
          data-name="Ligne 90"
          x2="8.666"
          transform="translate(91.367 10.627)"
          fill="none"
          stroke="#00a1a2"
          strokeWidth="1.5"
        />
        <path
          id="Tracé_84024"
          data-name="Tracé 84024"
          d="M0,0H7.143"
          transform="translate(91.366 14.225)"
          fill="#fff"
          stroke="#00a1a2"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}

export default SvgNoteWhite;
